import { Box, Typography, styled } from '@mui/material';

import { FONT_FAMILY } from '@/shared/ui/form-fields/fieldStyles';

export const TariffGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  columnGap: '1rem',
  rowGap: '1rem',
  alignItems: 'center',
  '& > *': { whiteSpace: 'nowrap' },
});

export const TariffDivider = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 2',
  height: '1px',
  backgroundColor: theme.palette.grey[200],
}));

export const TariffTotal = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1rem',
  padding: '0.75rem',
  borderRadius: '0.75rem',
  backgroundColor: theme.palette.blue[50],
}));

export const TariffTotalLabel = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '1rem',
  fontWeight: 350,
  lineHeight: 1.25,
  color: theme.palette.blue[600],
}));

export const TariffTotalValue = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '1.125rem',
  fontWeight: 400,
  lineHeight: 1.25,
  color: theme.palette.grey[900],
  whiteSpace: 'nowrap',
}));
